{
    "26": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "hammer",
        "name": "Beheader",
        "maxhealth": "20",
        "key": 26,
        "position": {
            "x": 13,
            "y": 5,
            "z": 1
        },
        "level": 1
    },
    "27": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "hammer",
        "name": "Beheader",
        "maxhealth": "20",
        "key": 27,
        "position": {
            "x": 15,
            "y": 5,
            "z": 1
        },
        "level": 1
    },
    "28": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "sword",
        "name": "Bladefiend",
        "key": 28,
        "position": {
            "x": 16,
            "y": 9,
            "z": 1
        },
        "level": 1
    },
    "30": {
        "type": "zone",
        "key": 30,
        "position": {
            "x": 16,
            "y": 13,
            "z": 1
        },
        "level": 1
    },
    "31": {
        "type": "zone",
        "key": 31,
        "position": {
            "x": 15,
            "y": 12,
            "z": 1
        },
        "level": 1
    },
    "32": {
        "type": "zone",
        "key": 32,
        "position": {
            "x": 12,
            "y": 14,
            "z": 1
        },
        "level": 1
    },
    "33": {
        "type": "zone",
        "key": 33,
        "position": {
            "x": 11,
            "y": 14,
            "z": 1
        },
        "level": 1
    },
    "34": {
        "type": "zone",
        "key": 34,
        "position": {
            "x": 10,
            "y": 14,
            "z": 1
        },
        "level": 1
    },
    "35": {
        "type": "zone",
        "key": 35,
        "position": {
            "x": 11,
            "y": 8,
            "z": 1
        },
        "level": 1
    },
    "36": {
        "type": "zone",
        "key": 36,
        "position": {
            "x": 10,
            "y": 8,
            "z": 1
        },
        "level": 1
    },
    "37": {
        "type": "zone",
        "key": 37,
        "position": {
            "x": 10,
            "y": 9,
            "z": 1
        },
        "level": 1
    },
    "38": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "hammer",
        "name": "Beheader",
        "maxhealth": "20",
        "key": 38,
        "position": {
            "x": 14,
            "y": 6,
            "z": 1
        },
        "level": 1
    },
    "39": {
        "type": "zone",
        "key": 39,
        "position": {
            "x": 14,
            "y": 7,
            "z": 1
        },
        "level": 1
    },
    "40": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "dagger",
        "name": "Daggerimp",
        "key": 40,
        "position": {
            "x": 14,
            "y": 11,
            "z": 1
        },
        "level": 1
    },
    "42": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "sword",
        "name": "Bladefiend",
        "key": 42,
        "position": {
            "x": 13,
            "y": 9,
            "z": 1
        },
        "level": 1
    },
    "46": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "spear",
        "name": "Speardevil",
        "key": 46,
        "position": {
            "x": 15,
            "y": 16,
            "z": 1
        },
        "level": 1
    },
    "48": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "spear",
        "name": "Speardevil",
        "key": 48,
        "position": {
            "x": 13,
            "y": 13,
            "z": 1
        },
        "level": 1
    },
    "50": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "spear",
        "name": "Speardevil",
        "key": 50,
        "position": {
            "x": 11,
            "y": 10,
            "z": 1
        },
        "level": 1
    },
    "52": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "sword",
        "name": "Bladefiend",
        "key": 52,
        "position": {
            "x": 9,
            "y": 13,
            "z": 1
        },
        "level": 1
    },
    "53": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "dagger",
        "name": "Daggerimp",
        "key": 53,
        "position": {
            "x": 10,
            "y": 11,
            "z": 1
        },
        "level": 1
    },
    "62": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "dagger",
        "name": "Daggerimp",
        "key": 62,
        "position": {
            "x": 7,
            "y": 8,
            "z": 1
        },
        "level": 1
    },
    "63": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "dagger",
        "name": "Daggerimp",
        "key": 63,
        "position": {
            "x": 11,
            "y": 5,
            "z": 1
        },
        "level": 1
    },
    "64": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "dagger",
        "name": "Daggerimp",
        "key": 64,
        "position": {
            "x": 8,
            "y": 6,
            "z": 1
        },
        "level": 1
    },
    "swordlord": {
        "key": "swordlord",
        "position": {
            "x": 14,
            "y": 3,
            "z": 1
        },
        "level": 1
    },
    "daggercloak": {
        "affiliation": "none",
        "key": "daggercloak",
        "position": {
            "x": 16,
            "y": 10,
            "z": 1
        },
        "level": 1
    },
    "axeknight": {
        "affiliation": "none",
        "key": "axeknight",
        "position": {
            "x": 15,
            "y": 15,
            "z": 1
        },
        "level": 1
    },
    "archdevil": {
        "affiliation": "bad",
        "bodyKey": "devil",
        "faceKey": "devil",
        "jobKey": "spear",
        "name": "Ire",
        "key": "archdevil",
        "maxhealth": 30,
        "position": {
            "x": 7,
            "y": 5,
            "z": 1
        },
        "level": 1
    }
}
